/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as defs from './identity/defs.js'
export * as getRecommendedDidCredentials from './identity/getRecommendedDidCredentials.js'
export * as refreshIdentity from './identity/refreshIdentity.js'
export * as requestPlcOperationSignature from './identity/requestPlcOperationSignature.js'
export * as resolveDid from './identity/resolveDid.js'
export * as resolveHandle from './identity/resolveHandle.js'
export * as resolveIdentity from './identity/resolveIdentity.js'
export * as signPlcOperation from './identity/signPlcOperation.js'
export * as submitPlcOperation from './identity/submitPlcOperation.js'
export * as updateHandle from './identity/updateHandle.js'
